"use client";

import { useSelection } from "@frend-digital/centra/client";

export const useCartItemCount = () => {
  const { data } = useSelection({
    select: data => data?.selection?.items?.length,
  });

  return data;
};

export const useCart = () => {
  const itemCount = useCartItemCount();

  return useSelection({
    select: data => {
      const items = data?.selection?.items ?? [];
      const currency = data?.selection?.currency;
      const vouchers = data?.selection?.discounts?.vouchers;
      const automaticDiscounts = data?.selection?.discounts?.automaticDiscounts;

      const priceAllItemsBeforeDiscountAsNumber = items.reduce(
        (acc, item) => acc + (item.priceEachBeforeDiscountAsNumber ?? 0),
        0,
      );
      const priceAllItemsAfterDiscountAsNumber = items.reduce(
        (acc, item) => acc + (item.priceEachAsNumber ?? 0),
        0,
      );
      const totalItemsDiscountPriceAsNumber =
        priceAllItemsBeforeDiscountAsNumber -
        priceAllItemsAfterDiscountAsNumber;

      const vouchersDiscountPriceAsNumber = (vouchers ?? []).reduce(
        (acc, voucher) => acc + (voucher.priceOffAsNumber ?? 0),
        0,
      );

      const automaticDiscountPriceAsNumber = (automaticDiscounts ?? [])
        .map(discount => {
          const isFreeProductDiscount = "freeProductAdded" in discount;

          if (isFreeProductDiscount) {
            const freeProductLine = (
              discount.freeProductAdded as { line?: string }
            ).line;
            const freeProduct = items.find(
              item => item.line === freeProductLine,
            );
            return freeProduct?.priceEachBeforeDiscountAsNumber ?? 0;
          }

          return 0;
        })
        .reduce((acc, item) => acc + item, 0);

      const totalDiscountPriceAsNumber =
        totalItemsDiscountPriceAsNumber - vouchersDiscountPriceAsNumber;

      return {
        items,
        itemCount,
        totalPrice: data?.selection?.totals?.grandTotalPrice,
        totalPriceAsNumber: data?.selection?.totals?.grandTotalPriceAsNumber,
        itemsTotalPrice: data?.selection?.totals?.itemsTotalPrice,
        itemsTotalPriceAsNumber:
          data?.selection?.totals?.itemsTotalPriceAsNumber,
        shippingPrice: data?.selection?.totals?.shippingPrice,
        shippingPriceAsNumber: data?.selection?.totals?.shippingPriceAsNumber,
        totalItemsDiscountPrice: `${totalItemsDiscountPriceAsNumber} ${currency}`,
        totalItemsDiscountPriceAsNumber,
        vouchersDiscountPrice: `${vouchersDiscountPriceAsNumber} ${currency}`,
        vouchersDiscountPriceAsNumber,
        automaticDiscountPrice: `${automaticDiscountPriceAsNumber} ${currency}`,
        automaticDiscountPriceAsNumber,
        totalDiscountPrice: `${totalDiscountPriceAsNumber} ${currency}`,
        totalDiscountPriceAsNumber,
        vouchers,
        currency,
      };
    },
  });
};
